import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { GrocyStockLog } from '../../../../../core/entities/grocy/stock-logs/stock-log.entity';
import { GrocyDashboardService } from '../../../shared/services/dashboard.service';
import { GrocyActionDialogComponent } from '../action-dialog/action-dialog.component';

@Component({
  selector: 'app-grocy-recent-stock-logs',
  templateUrl: './recent-stock-logs.component.html',
  styleUrl: './recent-stock-logs.component.scss',
})
export class GrocyRecentStockLogsComponent extends GrocyActionDialogComponent {
  columns: string[] = ['rowCreatedAt', 'transactionType', 'amount', 'price', 'undo'];

  constructor(service: GrocyDashboardService) {
    super(service);
  }

  get isSubmitting(): boolean {
    return this.service.state.isSubmitting;
  }

  get recentStockLogs(): MatTableDataSource<GrocyStockLog> {
    return new MatTableDataSource(this.service.selectedProduct()?.recentStockLogs || []);
  }

  undoTransaction(transactionId: string): void {
    this.service.undoTransaction(transactionId).subscribe();
  }
}
